import React from 'react';
import Button from './Button';

const Hero = ({ 
  title, 
  subtitle, 
  buttonText, 
  buttonLink, 
  secondaryButtonText, 
  secondaryButtonLink,
  backgroundImage,
  align = 'center'
}) => {
  const heroStyle = backgroundImage ? {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: '#ffffff',
  } : {};
  
  return (
    <section className="hero" style={heroStyle}>
      <div className="container">
        <div className="hero-content" style={{textAlign: align}}>
          {title && <h1 className="hero-title">{title}</h1>}
          {subtitle && <p className="hero-subtitle">{subtitle}</p>}
          <div className="hero-buttons">
            {buttonText && (
              <Button 
                to={buttonLink} 
                type="primary" 
                size="large"
              >
                {buttonText}
              </Button>
            )}
            {secondaryButtonText && (
              <Button 
                to={secondaryButtonLink} 
                type="secondary" 
                size="large"
              >
                {secondaryButtonText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;